export const SET_SET_UP_BILLING_PERIOD_OPTIONS = '@@setUpBillingPeriod/set'

export const UPDATE_BILLING_SETTINGS = '@@setUpBillingPeriod/updateBillingSettings'
export const RESET_SET_UP_BILLING_PERIOD_OPTIONS = '@@setUpBillingPeriod/reset'

export const SYNC_BILLING_SETTING = '@@setUpBillingPeriod/syncBillingSetting'
